import { States } from "constants/constants";

export interface ApnPdeStockResult {
    id: number;
    parentId: number;
    parentModelName: string;
    parentType: ApnPdeStockType;
    apn: string | null;
    pde: string | null;
    states: States | null;
    supplierId: number | null;
    supplierName: string | null;
    linkedToSystem: boolean;
    parentLinkedToSystem: boolean;
    modelId: string;
    parentModelId: string;
}

export enum ApnPdeStockType {
    Managed,
    System
}
